import { InjectionToken } from '@angular/core';
export const FOLDERABLE_APP_CONFIG = new InjectionToken('Folderable App Config');
export const MAX_VIEW_DEPTH = 4;
